
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindApparent3 as ObiWindApparent3Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-apparent-3.js';
 
 
 

 
 export const ObiWindApparent3 = createComponent({
   react: React,
   tagName: 'obi-wind-apparent-3',
   elementClass: ObiWindApparent3Element,
   events: {
     
   }
  });
 
 